module.exports = __webpack_public_path__ + "img/1.fa69dd8a.jpg";